import { styled } from '@creditas-ui/react'
import banner from './login-banner.png'

const MainLayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

const Main = styled.main`
  flex-grow: 1;
  flex-shrink: 0;
  padding: 0px;
  display: flex;
`

const Img = styled.div`
  background: url(${banner}) no-repeat center center;
  flex-grow: 1;
  flex-shrink: 0;
  background-size: cover;
`

const MainForm = styled.div`
  -webkit-box-flex: 0;
  flex: 0 1 500px;
  padding: 0px 70px;
`

export { MainLayoutWrapper, Main, Img, MainForm }
